module.exports = __webpack_public_path__ + "img/buy-icon8-en.720d9ee.png";